/** Mobile portrait focal points reviewed against each original photo. Desktop stays unchanged. */
const positions: Record<string, string> = {
  "1-Oceanfront-Oahu-vacation-rental-exterior-with-direct-beach-access.png": "55% 50%",
  "2-Oceanfront-Oahu-vacation-rental-exterior-with-direct-beach-access.png": "52% 50%",
  "3-Oceanfront-Oahu-vacation-rental-exterior-with-direct-beach-access.png": "52% 50%",
  "4-Oceanfront-Oahu-vacation-rental-exterior-with-direct-beach-access.png": "55% 50%",
  "18-Beachfront-Oahu-vacation-rental-with-sandy-shoreline-and-clear-water.png": "62% 50%",
  "5-Oceanfront-Oahu-vacation-rental-exterior-with-direct-beach-access.png": "50% 50%",
  "6-Oceanfront-Oahu-vacation-rental-exterior-with-direct-beach-access.png": "50% 50%",
  "7-Oceanfront-Oahu-vacation-rental-exterior-with-direct-beach-access.png": "48% 50%",
  "8-Oceanfront-Oahu-vacation-rental-exterior-with-direct-beach-access.png": "55% 50%",
  "9-Spacious-living-room-in-Oahu-vacation-rental-with-ocean-views.png": "53% 50%",
  "10-Spacious-living-room-in-Oahu-vacation-rental-with-ocean-views.png": "28% 50%",
  "11-Modern-kitchen-in-Oahu-beach-house-vacation-rental.png": "56% 50%",
  "12-Clean-bathroom-in-Oahu-vacation-rental.png": "48% 50%",
  "14-Bright-bedroom-with-ocean-view-in-Oahu-Hawaii-vacation-rental.png": "50% 50%",
  "13-Bright-bedroom-with-ocean-view-in-Oahu-Hawaii-vacation-rental.png": "58% 50%",
  "16-Bright-bedroom-with-ocean-view-in-Oahu-Hawaii-vacation-rental.png": "62% 50%",
  "17-Bright-bedroom-with-ocean-view-in-Oahu-Hawaii-vacation-rental.png": "48% 50%",
  "15-Bright-bedroom-with-ocean-view-in-Oahu-Hawaii-vacation-rental.png": "50% 50%",
  "22-Beachfront-Oahu-vacation-rental-with-sandy-shoreline-and-clear-water.png": "53% 50%",
  "21-Beachfront-Oahu-vacation-rental-with-sandy-shoreline-and-clear-water.png": "62% 50%",
  "19-Beachfront-Oahu-vacation-rental-with-sandy-shoreline-and-clear-water.png": "52% 50%",
  "20-Beachfront-Oahu-vacation-rental-with-sandy-shoreline-and-clear-water.png": "57% 50%",
  "23-Beachfront-Oahu-vacation-rental-with-sandy-shoreline-and-clear-water.png": "60% 50%",
  "24-Oahu-beachfront-vacation-rental-near-Kualoa-Ranch-and-Chinamans-Hat-scaled.jpg": "66% 50%",
  "25-Oahu-beachfront-vacation-rental-near-Kualoa-Ranch-and-Chinamans-Hat-scaled.jpg": "62% 50%",
  "02-aerial-house-on-the-point.jpg": "30% 50%",
  "01-rooftop-deck-mokolii-view.jpg": "60% 50%",
  "03-exterior-glass-living-level-rooftop-deck.jpg": "40% 50%",
  "06-living-room-wall-of-glass.jpg": "68% 50%",
  "07-living-room-window-ocean-mountains.jpg": "58% 50%",
  "08-mokolii-through-living-room-glass.jpg": "55% 50%",
  "09-living-room-wide.jpg": "60% 50%",
  "10-kitchen-island-ocean.jpg": "50% 50%",
  "11-dining-kitchen-ocean.jpg": "45% 50%",
  "12-kitchen-counter.jpg": "38% 50%",
  "13-dining-table-window.jpg": "60% 50%",
  "14-primary-bedroom-deck-access.jpg": "65% 50%",
  "15-primary-bedroom-bed.jpg": "50% 50%",
  "16-mokolii-from-bedroom-door.jpg": "55% 50%",
  "17-second-bedroom-ocean-window.jpg": "45% 50%",
  "18-second-bedroom-wide.jpg": "58% 50%",
  "19-bunk-room-upper-deck.jpg": "52% 50%",
  "20-bunk-room-built-ins.jpg": "70% 50%",
  "21-bathroom-walk-in-shower.jpg": "48% 50%",
  "22-second-bathroom-arched-mirror.jpg": "50% 50%",
  "23-rooftop-deck-sofa-mokolii.jpg": "58% 50%",
  "24-rooftop-deck-mountain-view.jpg": "48% 50%",
  "25-rooftop-deck-wide-mountains.jpg": "56% 50%",
  "26-hammock-over-the-water.jpg": "58% 50%",
  "27-hammock-mokolii.jpg": "53% 50%",
  "28-aerial-rooftop-deck-palms.jpg": "48% 50%",
  "29-mountains-behind-the-house.jpg": "60% 50%",
  "30-mokolii-aerial.jpg": "100% 50%",
  "31-shoreline-toward-kualoa.jpg": "58% 50%",
};
export function mobilePhotoPosition(url: string) {
  return positions[url.split("/").pop()?.split("?")[0] || ""] || "50% 50%";
}
